/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Exclusive_Feature_Real_Tree_SubtitleInputs */

const en_subscription_exclusive_feature_real_tree_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Real_Tree_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Make the Earth a Better Place`)
};

const ar_subscription_exclusive_feature_real_tree_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Real_Tree_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اجعل الأرض مكانًا أفضل`)
};

const de_subscription_exclusive_feature_real_tree_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Real_Tree_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Erde zu einem besseren Ort machen`)
};

const es_subscription_exclusive_feature_real_tree_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Real_Tree_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haz de la Tierra un lugar mejor`)
};

const fr_subscription_exclusive_feature_real_tree_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Real_Tree_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ensemble, cultivons un monde meilleur`)
};

const it_subscription_exclusive_feature_real_tree_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Real_Tree_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rendi la Terra un posto migliore`)
};

const ja_subscription_exclusive_feature_real_tree_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Real_Tree_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`地球をより良い環境に`)
};

const ko_subscription_exclusive_feature_real_tree_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Real_Tree_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`지구를 더 나은 곳으로 만드세요`)
};

const pt_br_subscription_exclusive_feature_real_tree_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Real_Tree_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faça da Terra um lugar melhor`)
};

const ru_subscription_exclusive_feature_real_tree_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Real_Tree_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сделаем Землю лучше`)
};

const th_subscription_exclusive_feature_real_tree_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Real_Tree_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ทำให้โลกน่าอยู่มากขึ้น`)
};

const tr_subscription_exclusive_feature_real_tree_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Real_Tree_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dünyayı Daha İyi Bir Yer Haline Getir`)
};

const zh_cn_subscription_exclusive_feature_real_tree_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Real_Tree_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`让地球变得更美好`)
};

const zh_tw_subscription_exclusive_feature_real_tree_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Real_Tree_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`讓地球變得更美好`)
};

/**
* | output |
* | --- |
* | "Make the Earth a Better Place" |
*
* @param {Subscription_Exclusive_Feature_Real_Tree_SubtitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_exclusive_feature_real_tree_subtitle = /** @type {((inputs?: Subscription_Exclusive_Feature_Real_Tree_SubtitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Exclusive_Feature_Real_Tree_SubtitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_exclusive_feature_real_tree_subtitle(inputs)
	if (locale === "ar") return ar_subscription_exclusive_feature_real_tree_subtitle(inputs)
	if (locale === "de") return de_subscription_exclusive_feature_real_tree_subtitle(inputs)
	if (locale === "es") return es_subscription_exclusive_feature_real_tree_subtitle(inputs)
	if (locale === "fr") return fr_subscription_exclusive_feature_real_tree_subtitle(inputs)
	if (locale === "it") return it_subscription_exclusive_feature_real_tree_subtitle(inputs)
	if (locale === "ja") return ja_subscription_exclusive_feature_real_tree_subtitle(inputs)
	if (locale === "ko") return ko_subscription_exclusive_feature_real_tree_subtitle(inputs)
	if (locale === "pt_br") return pt_br_subscription_exclusive_feature_real_tree_subtitle(inputs)
	if (locale === "ru") return ru_subscription_exclusive_feature_real_tree_subtitle(inputs)
	if (locale === "th") return th_subscription_exclusive_feature_real_tree_subtitle(inputs)
	if (locale === "tr") return tr_subscription_exclusive_feature_real_tree_subtitle(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_exclusive_feature_real_tree_subtitle(inputs)
	return zh_tw_subscription_exclusive_feature_real_tree_subtitle(inputs)
});